import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService } from '../../../../tms-shared';
import { TmsWebBaseEditService } from '../../base';
import { ReportDocument } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class DocumentService extends TmsWebBaseEditService<ReportDocument, ReportDocument> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('Document', $localize`Document`, httpService, notificationService);
  }
  getDocument(documentName: string): Observable<ReportDocument> {
    return this.httpService.get<ReportDocument>(`${this.apiUrl}/GetDocument?documentName=${documentName}`);
  }

  getAllExternalDocuments(): Observable<ReportDocument[]> {
    return this.httpService.get<ReportDocument[]>(`${this.apiUrl}/GetAllExternalDocuments`);
  }
}
